import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

if (!supabaseUrl || !supabaseKey) {
  console.warn('[supabase] 环境变量缺失，请检查 .env 文件')
}

export const supabase = createClient(supabaseUrl || 'http://placeholder', supabaseKey || 'placeholder', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
})

// Edge Function 基础请求封装
const EDGE_URL = import.meta.env.VITE_EDGE_FUNCTION_URL

/**
 * 调用 Edge Function
 * @param {string} path 路径（不含前缀）
 * @param {Object} options fetch options
 */
export async function edgeFetch(path, options = {}) {
  const url = `${EDGE_URL}${path}`
  const { data: sessionData } = await supabase.auth.getSession()
  const token = sessionData?.session?.access_token

  const res = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  })

  const json = await res.json().catch(() => ({}))

  if (!res.ok || !json.success) {
    const msg = json.message || json.error || `请求失败: ${res.status}`
    throw new Error(msg)
  }

  return json.data
}
